import { useState } from 'react';
import Layout from 'antd/lib/layout';
import React from 'react';
import Typography from 'antd/lib/typography';
import { ICreateSavedFilter } from '../../../components/sidebar-filters/saved-filter/interface';
import { SidebarFiltersGroupCollapse } from '../../../components/sidebar-filters/SidebarFiltersGroupCollapse';
import { SidebarWrapper } from '../../../components/sidebar-filters/SidebarWrapper';
import { READINESS_TRACKING_PAGE_CONST } from './constants';
import { IReadinessTrackingSidebarFilters, useReadinessTrackingSidebarFiltersContext } from './ReadinessTrackingSidebarFiltersContext';
import { ReadinessTrackingSidebarTabs } from './ReadinessTrackingSidebarTabs';
import { SaveReadinessTrackingFiltersModal } from './SaveReadinessTrackingFiltersModal';

interface IReadinessTrackingSidebarProps {
    collapsed: boolean;
    onCollapseChange: (value: boolean) => void;
    totalRecords?: number;
    onFilterChange: (filter: IReadinessTrackingSidebarFilters) => void;
    gridComponent: React.ReactNode;
}

export const ReadinessTrackingSidebar: React.FC<IReadinessTrackingSidebarProps> = ({
    collapsed,
    onCollapseChange,
    totalRecords,
    onFilterChange,
    gridComponent,
}) => {
    const {
        selectedSavedFilter,
        handleSavedFilterSelect,
        handleCreateSavedFilter,
        isCreateFilterLoading,
        handleUpdateSavedFilter,
        isUpdateFilterLoading,
    } = useReadinessTrackingSidebarFiltersContext();

    const [saveFiltersModalOpen, setSaveFiltersModalOpen] = useState(false);

    const handleOpenSaveFiltersModal = (savedFilterData: ICreateSavedFilter | null) => {
        setSaveFiltersModalOpen(true);
        handleSavedFilterSelect(savedFilterData);
    };

    const handleCancelSaveFilters = () => {
        setSaveFiltersModalOpen(false);
        handleSavedFilterSelect(null);
    };

    const handleSaveFilters = async (filterData: ICreateSavedFilter) => {
        const upsertSavedFilter = filterData.id ? handleUpdateSavedFilter : handleCreateSavedFilter;

        await upsertSavedFilter(filterData);

        setSaveFiltersModalOpen(false);
        handleSavedFilterSelect(null);
    };

    return (
        <>
            <SidebarWrapper
                collapsed={collapsed}
                onCollapseChange={onCollapseChange}
                collapsedWidth={READINESS_TRACKING_PAGE_CONST.collapsedWidth}
                expandedWidth={READINESS_TRACKING_PAGE_CONST.expandedWidth}
            >
                <Layout.Content
                    style={{
                        padding: 0,
                        margin: 0,
                        height: '100%',
                    }}
                >
                    {!collapsed && (
                        <div style={{ padding: '14px 12px 8px' }}>
                            <Typography.Text>Total Records: {totalRecords}</Typography.Text>
                        </div>
                    )}
                    <SidebarFiltersGroupCollapse collapsed={collapsed} setCollapsed={onCollapseChange} selectedItemsCount={0} />

                    {!collapsed && (
                        <ReadinessTrackingSidebarTabs
                            onFilterChange={onFilterChange}
                            onOpenSaveFiltersModal={handleOpenSaveFiltersModal}
                            gridComponent={gridComponent}
                        />
                    )}
                </Layout.Content>
            </SidebarWrapper>

            {/* Modals goes here === */}
            {saveFiltersModalOpen && selectedSavedFilter && (
                <SaveReadinessTrackingFiltersModal
                    isLoading={isCreateFilterLoading || isUpdateFilterLoading}
                    initialSavedFilter={selectedSavedFilter}
                    onCancel={handleCancelSaveFilters}
                    onSave={handleSaveFilters}
                />
            )}
        </>
    );
};
